import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        Product: 'System',
        product: 'system',
        Products: 'Systems',
        products: 'systems',
        PRODUCT: 'SYSTEM',
        PRODUCTS: 'SYSTEMS',
        'PRODUCT TYPES': 'SYSTEMS TYPES'
      },
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;